import { TRESPONSE_FATIGUE_ALLOWANCE_MASTER } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';

export type TFatigueAllowanceTableRowPayload = {
  valuePercent: number;
};

export const FATIGUE_ALLOWANCE_TABLE_MODEL = {
  createModel: (data: TRESPONSE_FATIGUE_ALLOWANCE_MASTER['data']) => {
    return ModifiersZTableModel.createTableModel(
      data,
      {
        headerConfig: [
          { type: 'TEXT_CELL', text: 'Fatigue Type' },
          {
            type: 'TEXT_CELL',
            text: 'Allowance(%)',
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'number',
                min: 0,
                isMinInclusive: true,
                setValue: (v) => v.valuePercent,
              },
              metadata: {
                keyName: 'valuePercent',
                isRequired: true,
              },
            },
          },
        ],
        edit: {
          hasAddRow: false,
          hasDeleteRow: true,
        },
      },
      (item): TTableRowNode<TRESPONSE_FATIGUE_ALLOWANCE_MASTER['data'][number]> => ({
        type: 'ROW',
        rowItem: item,
        cells: [
          { type: 'TEXT_CELL', text: item.name },
          { type: 'TEXT_CELL', text: String(item.valuePercent) },
        ],
      }),
    );
  },
};
